import LegalLayout from "./LegalLayout";

export default function Support() {
  return (
    <LegalLayout title="Support" effectiveDate="June 1, 2026">
      <p><strong>Need help with SalesArena HQ?</strong> We are happy to help.</p>

      <p><strong>Email:</strong> <a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a><br />
      <strong>Response time:</strong> We typically reply within 1&ndash;2 business days.</p>

      <h2>Common questions</h2>

      <h3>How do I get started?</h3>
      <p>SalesArena HQ is a workplace app. A company owner creates the workspace and invites team members by email. Once invited, download the app, sign in, and you will see your team leaderboards, challenges, and feed.</p>

      <h3>I did not get my invite</h3>
      <p>Check your spam folder for an email from SalesArena HQ. If it has not arrived, ask your workspace owner to re-send it, or email us and we will help.</p>

      <h3>How do I reset my password?</h3>
      <p>On the login screen, tap Forgot Password and follow the emailed link. If you are stuck, email <a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a>.</p>

      <h3>How do I report or block someone?</h3>
      <p>In the team feed (The Pit), tap the three-dots menu on any post &mdash; or press and hold a chat message &mdash; to <strong>Report</strong> the post or <strong>Block</strong> the person. Blocking hides that person&apos;s posts, stories, and comments from you. Your workspace owner reviews reported content and can remove it.</p>

      <h3>How do I delete my account?</h3>
      <p>Open the app, go to <strong>More &rarr; Delete Account</strong>, and follow the prompts. This permanently removes your account. Workspace owners are asked to confirm by typing their company name, since deleting an owner account removes the entire workspace.</p>

      <h3>Billing</h3>
      <p>Subscriptions are managed by your workspace owner on the SalesArena HQ website. For billing questions, contact your owner or email us.</p>

      <h2>Legal</h2>
      <p><a href="/privacy">Privacy Policy</a> &nbsp;&middot;&nbsp; <a href="/terms">Terms of Service</a></p>

      <h2>Contact</h2>
      <p>For anything else, email <a href="mailto:support@salesarenahq.com">support@salesarenahq.com</a> and we will get back to you.</p>
    </LegalLayout>
  );
}
